import { Select, SelectChangeEvent, MenuItem} from '@mui/material'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { useAdRecruitStore } from 'src/stores/AdRecruitStore';

const menuProps = {
    PaperProps: {
        sx: {
          // maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
        paddingTop: 0,
        paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}

const sx = {
    height:'46px',
    minWidth: '102px',
    textAlign:'center',
    justifyContent:'center',
    border: '1px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    // '& svg': {
    //   right: '30%',
    //   transform: 'translateX(50%)',
    //   position: 'absolute',
    //   pointerEvents: 'none',
    // },
}

const DropBoxSx = {
    // justifyContent: 'center',
    // textAlign: 'center',
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

const AdRecruitSelectStatus = () => {
    const typeContent = ['전체','모집 예정','모집 중','선발 중','선발 완료']
    const status = useAdRecruitStore((state)=>state.status)
    const setField = useAdRecruitStore((state)=>state.setField)
    const handleTypeChange = (e:SelectChangeEvent<string>)=>{
      const value = e.target.value;
      setField('page',1)
      setField('status', value === '전체' ? '' : value.trim());
    }

  return (
      <Select
          displayEmpty
          value={status}
          onChange={handleTypeChange}
          renderValue={(selected) => `${selected}` || '상태' }
          MenuProps={menuProps}
          sx={sx}
          IconComponent={KeyboardArrowDown}
          >
          {typeContent.map((content, index) => (
              <MenuItem value={content.toString()} sx={DropBoxSx} key={index}>
                  {content}
              </MenuItem>
          ))}
      </Select>
  )
}

export default AdRecruitSelectStatus